import { BsThreeDotsVertical } from "react-icons/bs";
import {
    OnestBoldBig,
    OnestNormalSmall
} from "../styled/TextComponents";

export const IconInfoBigBlock = ({
  icon,
  backgroundColor,
  iconBackgroundColor,
  title,
  text,
  addCharToValue = null,
  onClick = null,
}) => {
  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        backgroundColor: backgroundColor,
        borderRadius: 20,
        padding: 15,
        boxSizing: "border-box",
        minWidth: 155,
        height: 155,
        position: "relative",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: 10,
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", gap: 10 }}>
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: 10,
              backgroundColor: iconBackgroundColor,
              display: "flex",
              alignItems: "center",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <img
              alt={"icon"}
              style={{
                //imageRendering: '-webkit-optimize-contrast',
                imageRendering: "crisp-edges",
                WebkitBackfaceVisibility: "hidden",
                backfaceVisibility: "hidden",
                WebkitTransform: "translateZ(0)",
                transform: "translateZ(0)",
              }}
              src={icon}
              loading="eager"
            />
          </div>
          <div style={{ width: 90 }}>
            <OnestNormalSmall>{title}</OnestNormalSmall>
          </div>
        </div>
      </div>
      {onClick !== null ? (
        <div
          style={{
            position: "absolute",
            top: 15,
            right: 10,
            padding: 5,
            cursor: "pointer",
          }}
          onClick={() => onClick()}
        >
          <BsThreeDotsVertical style={{ fontSize: 20 }} />
        </div>
      ) : (
        <></>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <OnestBoldBig>
          {text}
          {addCharToValue || ""}
        </OnestBoldBig>
      </div>
    </div>
  );
};
